app.controller('teacherEvaluationCtrl', [
    '$scope', '$rootScope', '$http', '$state', '$stateParams', 'mdContentService', function ($scope, $rootScope, $http, $state, $stateParams, mdContentService) {
    	var vm = this;

    	vm.loaded = false;

        vm.games = [];
        vm.gameStates = [];
        vm.gameDay = {};

        vm.game = null;
        vm.gameIndex = 0;

        $http.get('/api/gameday/games').then(function(response) {
            vm.games = response.data.games;
            vm.gameStates = response.data.gameStates;

            $http.get('/api/gameday').then(function(response) {
                vm.gameDay = response.data;
                vm.loaded = true;

                vm.gameIndex = 0;
                vm.game = vm.games[vm.gameIndex];

                mdContentService.triggerSyntheticScrollEvent();
            });
        });

        vm.setGameIndex = function(idx) {
            vm.gameIndex = idx;
            vm.game = vm.games[vm.gameIndex];
        }

        vm.print = function() {
            window.print();
        }

    }
]);